import Button from '@/components/Button';
import useReset from '@/hooks/useReset';
import { FormattedMessage } from 'react-intl';
import { Image } from '@/components/Image';

export function OrderErrorModal({ onAgainClick, errorMessage }: { onAgainClick: () => void; errorMessage: string }) {
  const { goHome } = useReset();

  return (
    <div className="absolute inset-0 w-screen h-screen bg-white flex flex-col items-center justify-center gap-[50px] z-10">
      <Image src="/images/bi.png" alt="bi" className="w-[216px]" width={216} />
      <div className="flex flex-col justify-center items-center">
        <div className="h-[61px] relative flex items-center justify-center bg-[#ffe3e3] rounded-[49px] px-8">
          <Image
            src="/icons/triangle.svg"
            alt=""
            className="absolute -bottom-2 left-1/2 -translate-x-1/2 rotate-180 -z-[1]"
            width={20}
            height={10}
          />
          <span className="text-[20px] leading-7 font-bold z-[1]">
            <FormattedMessage id="order_error_message" defaultMessage="Sorry, an issue occurred while processing your request!" />
          </span>
        </div>
        <Image src="/character/problem.png" alt="problem" width={340} height={340} />
      </div>
      <div className="flex flex-col items-center gap-4">
        <div className="text-[20px] font-bold text-black">{errorMessage || 'Error Code {}'}</div>
        <div className="text-[20px] leading-7 font-medium flex flex-col items-center">
          <span>
            <FormattedMessage id="order_error_desc1" defaultMessage="Something went wrong while processing your request." />
          </span>
          <span>
            <FormattedMessage id="order_error_desc2" defaultMessage="Please note the error code and contact our staff." />
          </span>
        </div>
      </div>
      <div className="flex gap-4">
        <Button
          className="bg-[#f5f5f5]"
          textColor={'#000'}
          onClick={() => {
            goHome();
          }}
        >
          <FormattedMessage id="order_button_main" defaultMessage="Go to main" />
        </Button>
        <Button data-primary onClick={onAgainClick}>
          <FormattedMessage id="order_button_again" defaultMessage="Try again" />
        </Button>
      </div>
    </div>
  );
}
